export default __webpack_public_path__ + "static/media/auth-signup.40a13698.png";